module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/fixed_footer_pc_41dcac69427fb37dcfb7ad2efea4a314.jpg";